export default {"src":"/_next/static/media/glovo-logo-rectangle.894864ed.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};